import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import apis from '@/apis/documentApi';
import DocumentDate from './DocumentDate.vue';
var date = new Date();

var DocumentList = /*#__PURE__*/function (_Vue) {
  _inherits(DocumentList, _Vue);

  var _super = _createSuper(DocumentList);

  function DocumentList() {
    var _this;

    _classCallCheck(this, DocumentList);

    _this = _super.call(this);
    _this.count = 0;
    _this.documentCountList = [];
    _this.selectMonth = date.getMonth() + 1;
    _this.selectYear = date.getFullYear();
    _this.activeItem = date.getFullYear().toString();
    return _this;
  }

  _createClass(DocumentList, [{
    key: "getDocumentCount",
    value: function getDocumentCount() {
      var _this2 = this;

      apis.getDocumentCount().then(function (res) {
        _this2.documentCountList = res.data;

        _this2.getCount();
      }).catch(function (_) {});
    }
  }, {
    key: "getCount",
    value: function getCount() {
      var list = this.documentCountList;
      var count = 0;

      for (var i = 0; i < list.length; i++) {
        count += list[i].count;
      }

      this.count = count;
    }
  }, {
    key: "handleSelectDate",
    value: function handleSelectDate(year, month) {
      this.selectMonth = month;
      this.selectYear = parseInt(year);
    }
  }, {
    key: "handleActiveItemChange",
    value: function handleActiveItemChange(year) {
      this.activeItem = year;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getDocumentCount();
    }
  }]);

  return DocumentList;
}(Vue);

DocumentList = __decorate([Component({
  components: {
    DocumentDate: DocumentDate
  }
})], DocumentList);
export default DocumentList;